import { io } from 'socket.io-client';
import { REACT_APP_WS_URL } from '../../setup/config';
import Cookies from 'js-cookie'


export const socket = io(REACT_APP_WS_URL, {
    auth: {
        token: Cookies.get('jwtTokenClient')
    }
})